import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { activeStepTitleSelector, activeStepKeySelector } from '../selectors/wizardSelectors';
import StepTitle from '../components/StepTitle/StepTitle';

const mapStateToProps = createStructuredSelector({
    activeStepTitle: activeStepTitleSelector,
    activeStepKey: activeStepKeySelector
});

export default withTranslation('common')(
    withRouter(
        connect(mapStateToProps, null)(StepTitle)
    )
);
